import { createRouter, createWebHistory } from "vue-router";

const routes = [
  {
    path: "/",
    name: "/",
    redirect: "/authentication/signin",
  },

  {
    path: "/authentication/signin",
    name: "Вхід",
    component: () => import("@/views/auth/Signin.vue"),
    meta: {
      layout: "AuthLayout",
    },
  },
  {
    path: "/authentication/signup",
    name: "Реєстрація",
    component: () => import("@/views/auth/Signup.vue"),
    meta: {
      layout: "AuthLayout",
    },
  },
  {
    path: "/email-confirmation/:tenantName/:confirmationId",
    name: "Підтвердження імейл-адреси",
    component: () => import("@/views/guest/EmailConfirmation.vue"),
    meta: {
      layout: "AuthLayout",
    },
  },
  {
    path: "/:pathMatch(.*)*",
    redirect: "/",
  },
];

const routerGuest = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  linkActiveClass: "active",
  linkExactActiveClass: "active",
});

export default routerGuest;
